import axios from "../../../config/axiosConfig";

export const getCatalogosNotas = () => axios.get("/api/notas/catalogos");
export const listarNotas = (params) => axios.get("/api/notas", { params });
export const crearNota = (body) => axios.post("/api/notas", body);
export const actualizarNota = (id, body) => axios.put(`/api/notas/${id}`, body);

export const listarArchivosNota = (id) => axios.get(`/api/notas/${id}/archivos`);
export const subirArchivosNota = (id, archivos) => {
  const fd = new FormData();
  archivos.forEach((f) => fd.append("archivos", f));
  return axios.post(`/api/notas/${id}/archivos`, fd);
};
export const eliminarArchivoNota = (archivoId) => axios.delete(`/api/notas/archivos/${archivoId}`);

export const mensajeError = (e, defecto) => e?.response?.data?.message || e?.response?.data?.error || e?.message || defecto;

export const formatearPeso = (bytes) => {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};
